import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawSpanishIcon from "./RawSpanishIcon.svg.jsx";

const SpanishIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawSpanishIcon} {...props} />;
});

SpanishIcon.displayName = "SpanishIcon";
export default SpanishIcon;
